import { Box, Typography } from '@mui/material';

function CubeTestReportSelectionBanner({ selection }) {
  const hasSelection = Boolean(
    selection?.customer_name
    || selection?.project_name
    || selection?.product_name
    || (selection?.total_dc_qty != null && selection?.total_dc_qty !== ''),
  );

  if (!hasSelection) {
    return null;
  }

  const mainItems = [
    { label: 'Customer', value: selection.customer_name },
    { label: 'Site', value: selection.project_name },
    { label: 'Grade', value: selection.product_name },
    { label: 'Qty', value: selection.total_dc_qty },
  ];

  const marketingItem = {
    label: 'Marketing',
    value: selection.marketing_name,
  };

  const renderItem = (item, sx = {}) => (
    <Box key={item.label} sx={{ flex: '0 1 auto', minWidth: 100, ...sx }}>
      <Typography
        variant="caption"
        sx={{
          opacity: 0.88,
          fontWeight: 600,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          display: 'block',
        }}
      >
        {item.label}
      </Typography>
      <Typography
        variant="body1"
        sx={{ fontWeight: 700, mt: 0.35, wordBreak: 'break-word', lineHeight: 1.35 }}
      >
        {item.value}
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        alignItems: 'stretch',
        mb: 2.5,
        px: 2.5,
        py: 1.75,
        borderRadius: '12px',
        background: 'linear-gradient(135deg, #186098 0%, #0090D8 55%, #40B8E8 100%)',
        boxShadow: '0 8px 20px rgba(0, 144, 216, 0.28)',
        color: '#fff',
      }}
    >
      {mainItems.map((item) => renderItem(item))}
      {renderItem(marketingItem, { ml: 'auto', textAlign: 'right', minWidth: 120 })}
    </Box>
  );
}

export default CubeTestReportSelectionBanner;
